export const RoutesLink = {
  authRoutes: {
    login: "/login",
    forgot: "/forgot-password",
  },
  dashboard: "/dashboard",
  profile: "/profile",

  // ─── Labor ──────────────────────────────────────────
  labor: "/labor",
  createLabor: "/labor/create",
  editLabor: "/labor/edit",
  laborDetail: "/labor/detail",
  bulkAddLabor: "/labor/bulk-add",

  // ─── Site ───────────────────────────────────────────
  site: "/site",
  createSite: "/site/create",
  editSite: "/site/edit",
  siteDetail: "/site/detail",

  // ─── Supervisor ─────────────────────────────────────
  supervisors: "/supervisors",
  createSupervisor: "/supervisors/create",
  editSupervisor: "/supervisors/edit",
  supervisorDetail: "/supervisors/detail",

  // ─── Department ─────────────────────────────────────
  department: "/department",
  createDepartment: "/department/create",
  editDepartment: "/department/edit",
  departmentDetail: "/department/detail",

  // ─── Shift ──────────────────────────────────────────
  shift: "/sift",
  createShift: "/sift/create",
  editShift: "/sift/create",
  shiftDetails: "/sift/detail",

  // ─── Wages ──────────────────────────────────────────
  wages: "/wages",
  wagePayment: "/wages/payment",
  wageRates: "/wages/rate",
  wageEmployees: "/wages/employees",
  wagePaymentHistory: "/wages/paymentHistory",

  // ─── Attendance ─────────────────────────────────────
  deviceAttendance: "/attendance/device",
  bulkAttendance: "/attendance/bulk",
  attendanceDetail: "/attendance/detail",

  // ─── Reports ────────────────────────────────────────
  reports: "/reports",
  labourReport: "/reports/labour",
  attendanceReport: "/reports/attendance",
  wageReport: "/reports/wage",
  paymentReport: "/reports/payment",
  contractorReport: "/reports/contractor",
};